import React from 'react';
import { Row, Col } from 'reactstrap';

import Accordion from '../../../components/Accordion';
import AccordionItem from '../../../components/Accordion/components/AccordionItem';
import DimensionsConcreteMember from './DimensionsConcreteMember';
import ReinforcementParameters from './ReinforcementParameters';
import { APP_TEXTS } from '../../../texts/texts';

const Rebar = props => (
  <Row>
      <Col sm="12">
        <Accordion className="application__accordion" appStatus={props.appStatus}>
          <AccordionItem id="ReinforcementParameters" title={APP_TEXTS.REINFORCEMENT_PARAMETERS_TITLE.Content}>
            <ReinforcementParameters />
          </AccordionItem>
          <AccordionItem id="DimensionsConcreteMember" title={APP_TEXTS.DIMENSIONS_CONCRETE_MEMBER_TITLE.Content}>
            <DimensionsConcreteMember />
          </AccordionItem>
        </Accordion>
      </Col>
    </Row>
);

export default Rebar;



// WEBPACK FOOTER //
// ./src/views/Dimension/Rebar/Rebar.js